import { on } from 'src/lib/utils';

/**
 * Embedded iframe
 * -----------------------------------------------------
 * 🔴 IMPORTANT: We overwrite links and add target _blank
 *             for most except download links
 */

function reLink(el) {
  // remove all data attributes
  Object.keys(el.dataset).forEach(item => el.removeAttribute(`data-${item}`));

  // relink
  const href = $(el).closest('.card').find('.card-title a').attr('href');
  el.setAttribute('href', href);
}

// Always skip download links
on(document, 'click', 'a:not(.js-download-image)', element => element.setAttribute('target', '_blank'));
// Set all links to target blank, so they don't open inside an iframe

if (App.config.user.id) {
  // If current user, relink report as inappropriate link to match card show page
  on(document, 'click', '.card-comment-actions a:last-child', element => reLink(element));
} else {
  // If not current user, relink links inside card-body and card-footer to match card show page
  on(document, 'click', '.card-footer a, .card-body div:not(.short) a:not(.js-download-image)', element => reLink(element));
}
